<template>
  <div class="edit-tenant">
    <div class="section-header">
      <div class="section-header__left">
        <div class="section-header__icon">
          <i class="el-icon-s-cooperation"></i>
        </div>
        <div>
          <h2 class="section-header__title">{{ tenant && tenant.name ? tenant.name : $t('settings.tenantEdit') }}</h2>
          <p class="section-header__subtitle">{{ $t('settings.tenantEdit') }}</p>
        </div>
      </div>

      <div class="section-header__actions">
        <base-button
          type="primary"
          icon="el-icon-office-building"
          @click="$router.push({path: `/app/tenants/${$route.params.id}/customers`})">
          {{ $t('settings.showTenantCustomers') }}
        </base-button>
        <base-button
          type="primary"
          icon="el-icon-s-custom"
          @click="$router.push({path: `/app/tenants/${$route.params.id}/accounts`})">
          {{ $t('settings.showTenantAccounts') }}
        </base-button>
        <base-button
          icon="el-icon-back"
          @click="$router.push({path: '/app/tenants'})">
          {{ $t('settings.backToTenants') }}
        </base-button>
      </div>
    </div>

    <tenant-form
      :tenant="tenant"
      mode="edit"
      @submit="onSubmit"
      :loading="loading">
    </tenant-form>
  </div>
</template>

<script>
import BaseButton from '@/components/common/BaseButton';
import {createNamespacedHelpers} from 'vuex';
import TenantForm from './TenantForm';

const tenantStateMappers = createNamespacedHelpers('tenant');

export default {
  name: "EditTenant",
  components: {TenantForm, BaseButton},
  data() {
    return {
      tenant: null,
      loading: false
    }
  },
  mounted() {
    this.getTenant();
  },
  beforeRouteUpdate(to, from, next) {
    this.getTenant();
    next();
  },
  methods: {
    ...tenantStateMappers.mapActions(['getTenantById', 'updateTenant']),
    getTenant() {
      this.loading = true;
      this.getTenantById(this.$route.params.id).then((tenant) => {
        this.tenant = tenant;
        this.loading = false;
      });
    },
    onSubmit(tenant) {
      this.loading = true;
      this.updateTenant({
        tenantId: this.$route.params.id,
        tenant
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('settings.patchSuccess')
        });
        this.loading = false;
      }).catch(() => {
        this.$message({
          type: 'error',
          message: this.$t('settings.genericHttpError')
        });
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.edit-tenant {
  padding: 0 15px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  &__left {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  &__icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      color: var(--bg-surface);
      font-size: 18px;
    }
  }

  &__title {
    margin: 0 0 2px;
    font-size: 17px;
    font-weight: 600;
    color: var(--text-primary);
    line-height: 1.3;
  }

  &__subtitle {
    margin: 0;
    font-size: 12px;
    color: var(--text-secondary);
    line-height: 1.4;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

@media (max-width: 767px) {
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;

    &__actions {
      flex-wrap: wrap;
    }
  }
}
</style>
